<script>

import {Doughnut} from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: {
    OIScore: {
      require: true
    },
    height: {
      default: null
    },
    legend: {
      default: false
    }
  },
  name: 'OIScore',
  data () {
    return {
      options: {
        legend: {
          display: true
        },
        tooltips: {
          enabled: false
        },
        title: {
          display: true,
          text: 'User level',
          textBaseline: 'middle',
          textAlign: 'center',
          font: '14 px Arial',
          fillStyle: 'black'
        },
        responsive: true,
        maintainAspectRatio: true,
        circumference: Math.PI,
        rotation: -Math.PI,
        cutoutPercentage: 70,
        plugins: {
          datalabels: {
            display: false
          }
        }
      },
      data: {
        datasets: [
          {
            backgroundColor: ['rgba(52, 152, 219, 0.4)'],
            borderColor: ['rgba(52, 152, 219 ,1)'],
            borderWidth: 1
          }
        ],
        labels: []
      },
      level: null
    }
  },
  methods: {
    draw: function () {
      this.renderChart(this.data, this.options)
    }
  },
  mounted () {
    this.addPlugin({
      id: 'text-plugin',
      afterDraw: (chart, option) => {
        const canvasBounds = this.$refs.canvas.getBoundingClientRect()
        let fontSz = Math.floor(canvasBounds.height * 0.15)
        chart.ctx.textBaseline = 'middle'
        chart.ctx.textAlign = 'center'
        chart.ctx.font = fontSz + 'px Arial'
        chart.ctx.fillStyle = 'black'
        if (this.legend === false) {
          chart.ctx.fillText(this.OIScore + '%', canvasBounds.width / 2, canvasBounds.height * 0.80)
        } else {
          chart.ctx.fillText(this.OIScore + '%', canvasBounds.width / 2, canvasBounds.height * 0.90)
        }

        let ratio = 0.08
        if (this.legend !== false) {
          ratio = 0.01
        }

        let decalWidth = canvasBounds.width * ratio
        let decalHeight = canvasBounds.width * ratio
        if (canvasBounds.width / 2 === canvasBounds.height) {
          decalHeight = 10
          decalWidth = canvasBounds.width * 0.13
        } else if (canvasBounds.width > canvasBounds.height) {
          if ((canvasBounds.width - canvasBounds.height) < canvasBounds.height) {
            decalWidth = ((canvasBounds.width - canvasBounds.height) / 2) * 0.6
            decalHeight = ((canvasBounds.width - canvasBounds.height) / 2) * 0.15
          } else {
            decalHeight = 10
            if (this.legend !== false) {
              decalWidth = 45 * this.$data._chart.aspectRatio
            } else {
              decalWidth = 39 * this.$data._chart.aspectRatio
            }
          }
        } else {
          decalWidth = ((canvasBounds.height - canvasBounds.width) / 2) * 0.6
          decalHeight = (canvasBounds.height - canvasBounds.width)
        }

        fontSz = Math.floor(canvasBounds.height * 0.05)
        chart.ctx.textBaseline = 'middle'
        chart.ctx.textAlign = 'center'
        chart.ctx.font = fontSz + 'px Arial'
        chart.ctx.fillStyle = 'grey'
        chart.ctx.fillText(0, decalWidth, canvasBounds.height - decalHeight)

        fontSz = Math.floor(canvasBounds.height * 0.05)
        chart.ctx.textBaseline = 'middle'
        chart.ctx.textAlign = 'center'
        chart.ctx.font = fontSz + 'px Arial'
        chart.ctx.fillStyle = 'grey'
        chart.ctx.fillText(100, canvasBounds.width - decalWidth, canvasBounds.height - decalHeight)
      }
    })

    this.data.datasets[0].data = [this.OIScore, 100 - this.OIScore]

    if (this.legend !== false) {
      this.options.legend.display = true
      this.data.labels = [this.legend]
    }
    this.draw()
  },
  beforeMount () {
    this.level = this.$user.level()
    this.options.title.text = 'User level: ' + this.level.current
    this.options.title.display = !this.legend
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/OIScore.vue